module.exports = __webpack_public_path__ + "img/guide_icon_3.9185c8da.svg";